"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Trie = (function () {
    function Trie(_splitJoin) {
        this._splitJoin = _splitJoin;
        this._root = {};
        this._valueMap = new WeakMap();
    }
    Trie.from = function (splitJoin, values) {
        var trie = new Trie(splitJoin);
        for (var _i = 0, _a = Object.entries(values); _i < _a.length; _i++) {
            var _b = _a[_i], k = _b[0], v = _b[1];
            trie.set(k, v);
        }
        return trie;
    };
    Trie.prototype.set = function (key, value) {
        var fragments = this._splitJoin.split(key);
        var node = this._getNode(fragments, true);
        this._valueMap.set(node, value);
    };
    Trie.prototype.get = function (key) {
        var fragments = this._splitJoin.split(key);
        var node = this._getNode(fragments);
        return node && this._valueMap.get(node);
    };
    Trie.prototype.listRelative = function (key) {
        var fragments = this._splitJoin.split(key);
        return this.list(key, fragments.length);
    };
    Trie.prototype.list = function (key, index) {
        if (index === void 0) { index = 0; }
        var result = {};
        this.walk(function (key, value) { return (result[key] = value); }, key, index);
        return result;
    };
    Trie.prototype.listEntries = function (key, index) {
        if (index === void 0) { index = 0; }
        var result = [];
        this.walk(function (key) { return result.push(key); }, key, index);
        return result;
    };
    Trie.prototype.walk = function (walker, key, index) {
        if (index === void 0) { index = 0; }
        var fragments = (key && this._splitJoin.split(key)) || [];
        var node = this._getNode(fragments);
        if (!node) {
            return;
        }
        this._walkNode(node, fragments.slice(index), walker);
    };
    Trie.prototype._walkNode = function (node, fragments, walker) {
        if (this._valueMap.has(node)) {
            walker(this._splitJoin.join(fragments), this._valueMap.get(node));
        }
        for (var _i = 0, _a = Object.entries(node); _i < _a.length; _i++) {
            var _b = _a[_i], name_1 = _b[0], subNode = _b[1];
            this._walkNode(subNode, fragments.concat([name_1]), walker);
        }
    };
    Trie.prototype._getNode = function (fragments, force) {
        var node = this._root;
        for (var _i = 0, fragments_1 = fragments; _i < fragments_1.length; _i++) {
            var next = fragments_1[_i];
            var nextNode = node[next];
            if (!nextNode) {
                if (!force) {
                    return undefined;
                }
                nextNode = {};
                node[next] = nextNode;
            }
            node = nextNode;
        }
        return node;
    };
    return Trie;
}());
exports.default = Trie;
//# sourceMappingURL=trie.js.map


// WEBPACK FOOTER //
// ../src/trie.ts